export enum MergeStepLabel {
  STRUCTURE = 'structure',
  COMPONENT_TYPES = 'component types',
  REFERENCE_TYPES = 'reference types',
  FIELDS = 'fields',
  COMPONENTS = 'components',
  REFERENCES = 'references',
  TAGS = 'tags',
}
